<template>
  <v-container fluid>
    <v-row>
      <Banner />
      <v-col class="form-half" cols="12" md="6">
        <v-row class="fill-height pa-0 ma-0" align="center">
          <v-col cols="12" md="9">
            <v-container>
              <img src="@/assets/Global/images/svg/dark-logo.svg" class="auth-layout-logo" alt="" />
              <br /><br />
              <h2>Proceed</h2>
              <br />
              <div>
                <v-form ref="form">
                  <label>Email</label>
                  <v-text-field
                    label="example@gmail.com"
                    :rules="emailRules"
                    single-line
                    color="#F36F2E"
                    v-model="email"
                    outlined
                  ></v-text-field>

                  <Button
                    @click="validateForm"
                    :loading="loading"
                    :disabled="!isComplete"
                    >Recover Password</Button
                  >
                </v-form>
                <br />
                <center>
                  <p>
                    <router-link to="/login"> Remember Password ? </router-link>
                  </p>
                </center>
              </div>
            </v-container>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import Button from "@/components/Buttons/default-button.vue";
import Banner from "../components/banner.vue";
import { mapActions } from "vuex";

export default {
  data: () => ({
    loading: false,
    email: "",
    emailRules: [
      (v) => !!v || "Email is required",
      (v) =>
        /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v
        ) || "Email must be valid",
    ],
  }),
  components: {
    Button,
    Banner,
  },
  computed: {
    isComplete() {
      return this.email;
    },
  },
  methods:{
    ...mapActions("auth", ["recover"]),
    validateForm() {
      if (this.$refs.form.validate()) {
        localStorage.setItem('email', this.email);
        this.$router.push('/reset-password');
        // this.submitForm();
      }
    },
    async submitForm() {
      this.loading = true;
      let form = {
        email: this.email,
      };
      try {
        await this.recover(form);
      } catch (err) {
        this.loading = false;
        for (const errors in err) {
          let errorName = this[errors];
          this[errors + "Rules"].push(
            (v) => (v && v !== errorName) || err[errors]
          );
          this.$refs.form.validate();
        }
      }
    },

  }
};
</script>

<style lang="scss" scoped>
@import '../components/style.scss';
</style>